import { render, staticRenderFns } from "./DoctorNotesTable.vue?vue&type=template&id=601c3fb8&"
import script from "./DoctorNotesTable.vue?vue&type=script&lang=js&"
export * from "./DoctorNotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports